import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevrons-down-left', 'IconChevronsDownLeft', [["path",{"d":"M11 5v8h8","key":"svg-0"}],["path",{"d":"M7 9v8h8","key":"svg-1"}]]);